"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nuoro": {
    "d7aecffc": [{
      "hkey": "334e8bc7",
      "slug": "citta-giardino-monte-gurtei",
      "name": "Città Giardino-Monte Gurtei",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "334e8bc7",
      "slug": "citta-giardino-monte-gurtei",
      "name": "Città Giardino-Monte Gurtei",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "nuoro"
    }],
    "0ee6452b": [{
      "hkey": "f1ed8363",
      "slug": "istiritta-mughina-via-kennedy",
      "name": "Istiritta-Mughina-Via Kennedy",
      "primary": true,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "f1ed8363",
      "slug": "istiritta-mughina-via-kennedy",
      "name": "Istiritta-Mughina-Via Kennedy",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "nuoro"
    }]
  }
};
exports["default"] = _default;